import React from 'react'
import { Theme, withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import { Grid, makeStyles } from '@material-ui/core'
import { isMobile } from 'react-device-detect'
import close from '../assets/images/close.svg'

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent)

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions)

interface ChartTooltipModalProps {
  open?: any
  setOpen?: any
  handleClose?: any
  tooltipInfo?: any
}
const useStyles = makeStyles({
  content: {
    background: '#FFFFFF',
    boxSizing: 'border-box',
    borderRadius: 3,
    padding: '24 24',
  },
  title: {
    color: '#3393F3',
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  closeBtn: {
    float: 'right',
  },
  subTitle: {
    fontSize: 12,
    color: '#3393F3',
    fontWeight: 400,
  },
  detailContent: {
    marginBottom: 12,
  },
  header: {
    marginBottom: 12,
    '& input': {
      float: 'right',
    },
  },
  mobileHeader: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  typeHead: {
    fontSize: 14,
    color: 'rgba(24, 24, 24, 1)',
    fontWeight: 600,
  },
  pDetail: {
    marginTop: 10,
    lineHeight: '20px',
    fontWeight: 400,
    fontSize: 14,
  },
  typeDetail: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
  },
})

const DriverTooltipModal = ({
  open,
  setOpen,
  handleClose,
  tooltipInfo,
}: ChartTooltipModalProps) => {
  const classes = useStyles()
  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogContent>
          <div className={classes.content}>
            {isMobile && (
              <div className={classes.header}>
                <div className={classes.mobileHeader}>
                  <span className={classes.title}>{tooltipInfo.title}</span>
                  <input
                    className={classes.closeBtn}
                    type="image"
                    onClick={() => handleClose()}
                    src={close}
                    alt="closeBtn"
                  />
                </div>
                {tooltipInfo.subTitle && (
                  <span className={classes.subTitle}>
                    {' '}
                    ({tooltipInfo.subTitle})
                  </span>
                )}
              </div>
            )}

            {!isMobile && (
              <div className={classes.header}>
                <span className={classes.title}>{tooltipInfo.title}</span>
                {tooltipInfo.subTitle && (
                  <span className={classes.subTitle}>
                    {' '}
                    ({tooltipInfo.subTitle})
                  </span>
                )}
                <input
                  type="image"
                  onClick={() => handleClose()}
                  src={close}
                  alt="closeBtn"
                />
              </div>
            )}

            <div className={classes.detailContent}>
              <div className={classes.pDetail}>
                <p>
                  This chart allows you to look at the underlying drivers of the
                  credit Stress measure; Asset volatility, market value of
                  leverage and market value of assets. You can switch these on
                  and off using the appropriate toggles, with the ability to
                  overlay them all into one view. The tool tip will show you the
                  data points of each driver, allowing for a quick and easy
                  combined assessment.
                </p>
                <p style={{ marginTop: 10 }}>
                  The definition of each of the driving components:
                </p>
              </div>
            </div>

            <div className={classes.detailContent}>
              <span className={classes.typeHead}>
                MARKET VALUE OF ASSETS (ASSET VALUE):{' '}
              </span>
              <span className={classes.typeDetail}>
                The market’s view of the enterprise value of the firm as
                determined by the firm’s equity value, equity volatility and
                liability structure. We use a proprietary option theoretic model
                to compute the market value of assets, since it is not directly
                observable.
              </span>
            </div>

            <div className={classes.detailContent}>
              <span className={classes.typeHead}>MARKET LEVERAGE: </span>
              <span className={classes.typeDetail}>
                The market leverage is a ratio indicating how much of the market
                value of the firm’s assets is financed by debt. It is calculated
                by dividing the default point (The level at which an enterprise
                is assumed to default on its debt obligations) by the market
                value of assets. If everything else is equal, the higher the
                firm’s market leverage, the higher the firm’s credit stress
                measure credit measure.
              </span>
            </div>

            <div className={classes.detailContent}>
              <span className={classes.typeHead}>ASSET VOLATILITY: </span>
              <span className={classes.typeDetail}>
                Asset volatility is a measure of the business risk of the firm.
                Technically, it is the standard deviation of the annual change
                in the market value of the assets, as measured against the
                firm’s benchmark group, expressed in percentage terms. The
                higher the asset volatility, the less certain investors are
                about the market value of the firm, and the more likely the
                firm’s value will fall below its default point.
              </span>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default React.memo(DriverTooltipModal)
